import { UserFeatureFlags } from 'enums/user-membership-features';
import { createSelector } from 'reselect';

const selectFeatureFlags = (state) => state?.get('featureFlags');
const selectFeatureFromProps = (_, props) => props.flag;

const makeSelectFeatureFlags = () =>
  createSelector(selectFeatureFlags, (state) => state.getIn(['flags'], null));
/**
 * @name makeSelectFeatureFlagActive
 * @description
 * Selector that check if the provided flag name is active.
 */
const makeSelectFeatureFlagActive = (flagName, allowUndefined = false) =>
  createSelector(selectFeatureFlags, (state) => {
    const defaultValue = allowUndefined ? true : false;
    return state.getIn(['flags', flagName], defaultValue) ?? defaultValue;
  });

const makeSelectFeatureFlagAccountConnections = () =>
  createSelector(selectFeatureFlags, (state) => {
    const accountingConnectionsFeatureFlag = state.getIn(
      ['flags', UserFeatureFlags.accountingConnections],
      undefined,
    );
    if (accountingConnectionsFeatureFlag === false) {
      return false;
    }
    return true;
  });

/**
 * @name makeSelectFeatureFlagActiveFromProps
 * @description
 * Selector that check if the flag name provided on the props is active
 */
const makeSelectFeatureFlagActiveFromProps = () =>
  createSelector(selectFeatureFromProps, selectFeatureFlags, (flagName, state) =>
    !flagName ? false : state.getIn(['flags', flagName], false),
  );

export {
  selectFeatureFlags,
  makeSelectFeatureFlags,
  makeSelectFeatureFlagActive,
  makeSelectFeatureFlagAccountConnections,
  makeSelectFeatureFlagActiveFromProps,
};
